module.exports = __webpack_public_path__ + "static/media/Riviera_Level_05.6720a40c.jpg";